import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import './assets/tailwind.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

const app = createApp(App)

app.use(router)
app.use(store)
store.dispatch('init');
app.mount('#app')

AOS.init()
